import React from "react";
import { FormControl} from "react-bootstrap";
import PropTypes from "prop-types";
import classes from "./FeatureDisplay.module.scss";

const FeatureDisplay = ({
  t,
  displayCount,
  onChange,
  options = [5, 10, 20, 50],
  maxWidth = "50px",
}) => {
  return (
    <div className={classes["feature-display-container"]} style={{ maxWidth }}>
        <p className={classes["feature-display-container-p"]}>{t("show")}</p>
      <FormControl
        as="select"
        value={displayCount}
        onChange={(e) => onChange(parseInt(e.target.value))}
        className={classes["feature-display"]}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </FormControl>
    </div>
  );
};

FeatureDisplay.propTypes = {
  t: PropTypes.func.isRequired,
  displayCount: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.number),
  maxWidth: PropTypes.string,
};

export default FeatureDisplay;
